@if (data$ | async; as data) {<p [innerHTML]="getHTML(data.content)" [classList]="styleClasses ? styleClasses : ''"></p>}